<template>
  <div class="section-boxed">
    <div class="pexeto-recent-posts rp-list">
      <h3 class="rp-title">
        <router-link to="/articles">{{ $t("article") }}</router-link>
      </h3>
      <div class="pb-10">
        <v-expansion-panel>
          <v-expansion-panel-content v-for="item in articles" :key="item.Id">
            <template v-slot:header>
              <h3>{{item.Name}}</h3>
            </template>
            <v-card>
              <v-card-text>
                <div v-if="item.Thumbnail" class="rp-date">
                  <img class="wp-post-image" :src="item.Thumbnail" :alt="item.Name" />
                </div>
                <div class="rp-info">
                  <h3 class="pt-0">
                    <router-link :to="item.SeName" :title="item.Name">{{item.Name}}</router-link>
                  </h3>
                  <div class="rp-cat">
                    <router-link :to="item.SeName" :title="item.Short">{{item.Short}}</router-link>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>
    </div>
  </div>
</template>
<script>
/* globals Store */
import { mapState } from "vuex";

export default {
  mounted() {
    this.getArticles();
  },
  computed: {
    ...mapState("articles", {
      articles: "articles",
      pagination: "pagination"
    })
  },
  methods: {
    getArticles() {
      Store.dispatch("articles/getItems", {
        query: "",
        pagination: { page: 1, rowsPerPage: 5 }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// HomeArticle.vue?ab717e38